<template>
	<div class="live-discuss">
		<div class="mesContainer" ref="mesContainer" id="message-items" @click="previewImages">
			<van-pull-refresh v-if="!isEmpty" v-model="isLoading" @refresh="getChatRecord" pullimg-text="下拉查看历史消息"
				loosing-text="释放查看历史消息" :disabled="disabledPull">
				<div class="message-item" v-for="(item) in topicList" :class="[item.direction, item.isAdmin]"
					:key="item.id">
					<img src="@/assets/images/defaultHead.png" alt="" v-if="!item.avatar">
					<img v-else :src="item.avatar" alt="">


					<div class="content">
						<span></span>
						<p v-html="item.msg"></p>
					</div>
				</div>
			</van-pull-refresh>
			<div class="noData" v-if="isEmpty">
				<img src="../../../../assets/images/noData2.png" alt="">
				<p>欢迎大家参与讨论</p>
			</div>
		</div>
		<div class="comment-input flex">
			<input type="text" placeholder="说点什么..." ref="commentInput" v-model="content">
			<img src="@/assets/images/giveLike.png" alt="" class="give-like" @click="giveLike" v-if="isWX">
			<button @click="sendDiscuss" v-if="color" :style="{ backgroundColor: color }">发送</button>
			<button @click="sendDiscuss" v-else>发送</button>
		</div>

	</div>
</template>
<script>
import { PersoanalUserInfo, Signature, MeetingChat, MeetingchatList, MeetinganonymousChat } from "../../../../config/interface.js"
export default {
	props: {
		admin: Array,
		websock: WebSocket,
		topicList: Array,
		color: String
	},
	data() {

		return {
			disabledPull: false,   // 禁用下拉
			isLoading: false,
			isEmpty: false,
			content: '',
			userInfo: this.$store.state.userInfo,
			value: 0,
			obj: '',
			room_id: this.$route.query.id,      //房间号
			pingTimer: null,             //定时器
			userId: 0,
			signatureInfo: {},    //签名信息
			last_id: 0,
			isWX: false,
			images: [],
		}
	},
	created() {
	},
	watch: {
		topicList(oldData, newData) {
			this.isEmpty = newData.length > 0 ? false : true;
			this.backBottom();
		}
	},
	mounted() {
		this.getSignature();
		let keyTimer = null;
		document.body.addEventListener('focusin', () => {
			//软键盘弹起事件
			clearInterval(keyTimer);
		});
		document.body.addEventListener('focusout', () => {
			// 软键盘关闭事件
			window.scrollTo(0, 0);
			keyTimer = setTimeout(() => {
				if (window.pageYOffset > 0) {
					window.scrollTo(0, 0);
				}
			}, 200);
		})
	},
	methods: {
		//获取用户信息
		getUserInfo() {
			const url = PersoanalUserInfo;
			let params = {};
			const method = 'POST';
			fetch(url, params, method)
				.then((res) => {
					if (res.code == 0) {
						let data = res.data;
						this.userInfo = data;
						localStorage.setItem('userInfo', JSON.stringify(data));
						this.$store.dispatch('storageUserInfo', data);
						this.getSignature();

					}
				})

		},
		//得到签名
		getSignature() {
			if (Object.keys(this.signatureInfo).length == 0) {
				const url = Signature;
				const method = 'POST';
				let params = {}
				fetch(url, params, method)
					.then((res) => {
						if (res.code == 0) {
							let data = res.data;
							this.signatureInfo = data;
							// if(!this.userInfo){
							// 	this.getUserInfo();
							// }else{
							this.getLiveChat();
							// }

						}
					})

			} else {
				if (!this.userInfo) {
					this.getUserInfo();
				}
			}


		},
		//查看聊天记录
		getChatRecord() {
			this.getLiveChat()
		},
		//查看实时聊天记录
		getLiveChat() {
			console.log('聊天记录');
			const url = MeetingChat;
			let params = {
				session_id: this.room_id,
				last_id: this.last_id
			}
			const methos = 'POST';
			fetch(url, params, methos)
				.then((res) => {
					if (res.code == 0) {
						let data = res.data;
						if (data.length > 0) {
							data.forEach((item, index) => {
								let obj = {
									avatar: item.avatar,
									msg: `<i>${item.nickname}</i><br> ${item.params.body}`,
									direction: this.userInfo.ecs_id == item.uasid ? 'right1' : 'left',
									isAdmin: item.params.from_admin ? 'admin' : '',
									id: item.id
								}
								this.topicList.unshift(obj);
								console.log(obj);
							})
							this.last_id == 0 ? this.backBottom() : '';
							this.last_id = data[data.length - 1].id;


						} else {
							if (this.last_id != 0) {
								common.toast('已经到顶了', 1000);    //第一次为空时不弹出弹窗
								this.disabledPull = true;
							}

						}
						this.isEmpty = this.topicList.length > 0 ? false : true;
						this.isLoading = false;
					}
				})
		},
		backBottom() {
			let ele = this.$refs.mesContainer;
			let scrollTop = 0;
			this.$nextTick(() => {
				if (ele.scrollHeight > ele.clientHeight) {
					scrollTop = ele.scrollHeight - ele.clientHeight + 44;
					this.$refs.mesContainer.scrollTop = scrollTop;
				}
			})
		},

		//数据发送
		websocketSendMessage() {
			let params = {
				"action": "send_to_all_room_member",
				"params": {
					"raw": {
						"body": this.content
					}
				},
				"room_id": this.room_id
			}
			this.websock.send(JSON.stringify(params));
			this.content = '';

		},
		//发送讨论
		sendDiscuss() {
			this.content != '' ? this.websocketSendMessage() : '';
		},
		//点赞
		giveLike() {
			this.content = '[emo:1]'
			this.content != '' ? this.websocketSendMessage() : '';
		},
		previewImages(e) {
			if (e.target && e.target['nodeName'] == "IMG" && e.target.className == "image-media-from-admin") {
				let previewArr = [];
				let imgs = this.$refs.mesContainer.querySelectorAll('img.image-media-from-admin');
				imgs.forEach((img) => {
					previewArr.push(common.fullUrlProtocol(img.getAttribute('src')));
				})
				console.log(previewArr);
				common.wxPreviewImage(common.fullUrlProtocol(e.target.getAttribute('src')), previewArr);
			}
		},
		// expandPhoto(img_src){
		//      var overlay = document.createElement("div");
		//      overlay.setAttribute("id","overlay");
		//      overlay.setAttribute("class","overlay");
		//      document.body.appendChild(overlay);

		//      var img = document.createElement("img");
		//      img.setAttribute("id","expand")
		//      img.setAttribute("class","overlayimg");
		//      img.src = img_src
		// 	 console.log(img_src)
		//      document.getElementById("overlay").appendChild(img);
		// 	//  img.addEventListener('click',this.restore())

		//  },
		// restore(){
		// 	 const overlay_id=document.getElementById("overlay")
		// 	 const expand_id=document.getElementById("expand")
		// 	 if(overlay_id){
		// 		document.body.removeChild(overlay_id);
		// 	 }
		// 	 if(expand_id){
		// 		document.body.removeChild(expand_id);
		// 	 }
		//  }
	}
}
</script>
<style lang="scss">
.live-discuss {
	height: calc(100vh - 360px);

	.mesContainer {
		padding: 15px;
		position: absolute;
		overflow: auto;
		top: 0px;
		bottom: 44px;
		width: 100%;
		box-sizing: border-box;

		.van-pull-refresh {
			min-height: 100%;
		}

		.message-item {
			@include flex(row);
			align-items: center;
			margin-bottom: 15px;

			img {
				width: 40px;
				height: 40px;
				border-radius: 50%;
			}

			.image-media-from-admin {
				width: 100%;
				height: auto;
				border-radius: 0;
			}

			.content {
				position: relative;
				margin-left: 20px;
				padding: 10px;
				background: white;
				border-radius: 2px;

				span {
					position: absolute;
					top: 50%;
					transform: translate(0, -50%);
					left: -20px;
					display: inline-block;
					border-top: 10px solid transparent;
					border-bottom: 10px solid transparent;
					border-left: 10px solid transparent;
					border-right: 10px solid white;
				}

				p {
					max-width: 200px;
					word-wrap: break-word;
					color: rgb(145, 142, 142);

					i {
						font-style: normal;
					}
				}
			}
		}

		.admin {
			p {
				// color:$color-main;

			}
		}

		.right1 {

			// transform: rotateY(180deg);
			// -ms-transform:rotateY(180deg); 
			// -webkit-transform:rotateY(180deg);
			.content {
				background: white;

				span {
					border-right: 10px solid white;
				}
			}

			img,
			p {

				// transform: rotateY(180deg);
				// -ms-transform:rotateY(180deg); 
				// -webkit-transform:rotateY(180deg); 
				i {
					color: rgb(46, 102, 223);
				}
			}

		}

		.left {
			i {
				color: black
			}
		}
	}

	.comment-input {
		position: fixed;
		bottom: 0px;
		width: 100%;
		height: 44px;
		padding: 5px 15px;
		align-items: center;
		background-color: #f4f4f4;

		input {
			line-height: 34px;
			padding-left: 5px;
			flex: 1;
			border: 0px;
			font-size: 15px;
			color: #000;
		}

		.give-like {
			width: 25px;
			position: absolute;
			right: 75px;
		}

		button {
			margin-left: 5px;
			/*width:52px;*/
			height: 28px;
			border: 0px;
			padding: 0 10px;
			line-height: 28px;
			text-align: center;
			background-color: $color-main;
			font-size: 14px;
			color: #fff;
		}
	}

	.noData {
		text-align: center;

		img {
			width: 200px;
			margin-top: 20px;
		}
	}
}

.overlay {
	background-color: #000; //背景色
	opacity: 1.0; //不透明度
	filter: alpha(opacity=100); //透明度
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 10;
	overflow: auto; //滚动条
}

.overlayimg {
	position: absolute;
	z-index: 11;
	width: 99%; //宽度
	height: auto; //高度自动
}
</style>


// WEBPACK FOOTER //
// src/pages/VascularSystem/components/Meeting/Discuss.vue